import { render, staticRenderFns } from "./tabTruckingUICustomLayout.vue?vue&type=template&id=4b48a8b1&"
import script from "./tabTruckingUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabTruckingUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b48a8b1')) {
      api.createRecord('4b48a8b1', component.options)
    } else {
      api.reload('4b48a8b1', component.options)
    }
    module.hot.accept("./tabTruckingUICustomLayout.vue?vue&type=template&id=4b48a8b1&", function () {
      api.rerender('4b48a8b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabTruckingUICustomLayout.vue"
export default component.exports